import { initStore } from './redux/store.js'

// Init prelim stuff
export const { store, persistor } = initStore()
